import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { getPercentage } from "../../../Common/FewCommonMethods";
import CustomeCircularProgressbar from "../../../Common/CustomeLabel/CustomeCircularProgressbar";
import { getDateFormate } from "../../../Common/AllDateTimeReleventFormate";
import GetRemainDays from "../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetRemainDays";
import GetStatus from "../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetStatus";
import TeamsViewDetailsModel from "./TeamsModels/TeamsViewDetailsModel";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";
import GetRemainOnlyDays from "../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetRemainOnlyDays";

export default function TeamOverview({ teamoverview, setTeamroute, setProjectID, setProjectDetails }) {
  const due_today = teamoverview?.due_today;
  const today_task = teamoverview?.today_task;

  const [viewmodel, setviewModel] = useState(false);
  const [taskdetails, setTaskDetails] = useState(false);
  const [itemdata, setitemdata] = useState(false);

  const handleOpenTaskDetails = (item) => {
    setitemdata(item);
    setviewModel(true);
    setTaskDetails(item);
  }
  return (
    <div className="teamoverview">
      <div className="row active-row">
        <div className="col-md-3 signup-back col-6">
          <div className="signup-sec">
            <p>Total Tasks</p>
            <h4>{teamoverview?.task || 0}</h4>
          </div>
        </div>
        <div className="col-md-3 signup-back col-6">
          <div className="signup-sec">
            <p>Completed tasks</p>
            <h4>{teamoverview?.completed_task || 0} </h4>
          </div>
        </div>
        <div className="col-md-3 signup-back col-6">
          <div className="signup-sec">
            <p>Delayed tasks</p>
            <h4>{teamoverview?.delayed_task || 0}</h4>
          </div>
        </div>
        <div className="col-md-3 signup-back col-6">
          <div className="signup-sec">
            <p>In-Progress</p>
            <h4>{teamoverview?.in_progress_task || 0}</h4>
          </div>
        </div>
      </div>
      <div className="wokprogress">
        <div className="team-head">
          <h4>Work Progress</h4>
        </div>
        <div className="work-section">
          <div className="row justify-content-between">
            <div className="col-md-6">
              <div className="workprogress-row">
                {Array.isArray(teamoverview?.projects) &&
                  teamoverview?.projects?.map((item, index) => (
                    <div key={index} onClick={() => { setTeamroute('Tasklist'); setProjectID(item?.id); setProjectDetails(item) }}>
                      <h6>{item?.title}</h6>
                      <p>
                        {item?.completed_task} of {item?.task} tasks
                      </p>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${getPercentage(item?.task, item?.completed_task)}%`,
                          }}
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="col-md-2 col-6 mx-auto">
              <CustomeCircularProgressbar
                percentage={getPercentage(
                  teamoverview?.task,
                  teamoverview?.completed_task,
                )}
              />
            </div>
          </div>
        </div>
      </div>
      {Array.isArray(today_task) && today_task.length != 0 &&
        <div className="wokprogress">
          <div className="team-head">
            <h4>Today added tasks</h4>
          </div>
          <div className="row">
            {Array.isArray(today_task) &&
              today_task?.map((item, index) => (
                <div className="col-md-6" key={index} onClick={() => handleOpenTaskDetails(item)} >
                  <div className="today-task">
                    <h5>{item?.title}</h5>
                    <div className="assignee">
                      <h3>Assignee</h3>
                      <div className="assignee-sec">
                        <h4>
                          <img src={item?.profile_image ? item?.profile_image : ProfilePic} alt="" />
                          {item?.first_name} {item?.last_name}
                        </h4>
                        <p className="progress">
                          <span></span>
                        </p>
                        {item?.status == 1
                          ? "Assigned"
                          : item?.status == 2
                            ? "In Progress"
                            : item?.status == 3
                              ? "Completed"
                              : item?.status == 4
                                ? "Reopened"
                                : ""}
                      </div>
                      <div className="assignee">
                        <h3>Deadline</h3>
                        <div className="assignee-sec assignee-bottom">
                          <h4>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/calendar.svg`}
                              alt=""
                            />
                            {getDateFormate(item?.due_date)}
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/down-arrow.svg`}
                              alt=""
                            />
                          </h4>
                          {item?.status != 3 && <GetRemainOnlyDays enddate={item?.due_date} />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>}
      {Array.isArray(due_today) && due_today.length != 0 &&
        <div className="wokprogress">
          <div className="team-head">
            <h4>Due today</h4>
          </div>
          <div className="row">
            {Array.isArray(due_today) &&
              due_today?.map((item, index) => (
                <div className="col-md-6" key={index} onClick={() => handleOpenTaskDetails(item)} >
                  <div className="today-task">
                    <h5>{item?.title}</h5>
                    <div className="assignee">
                      <h3>Assignee</h3>
                      <div className="assignee-sec">
                        <h4>
                          <img src={item?.profile_image ? item?.profile_image : ProfilePic} alt="" />
                          {item?.first_name} {item?.last_name}
                        </h4>
                        <p className="progress">
                          <span></span>
                        </p>
                        {item?.status == 1
                          ? "Assigned"
                          : item?.status == 2
                            ? "In Progress"
                            : item?.status == 3
                              ? "Completed"
                              : item?.status == 4
                                ? "Reopened"
                                : ""}
                      </div>
                      <div className="assignee">
                        <h3>Deadline</h3>
                        <div className="assignee-sec assignee-bottom">
                          <h4>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/calendar.svg`}
                              alt=""
                            />
                            {getDateFormate(item?.due_date)}
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/down-arrow.svg`}
                              alt=""
                            />
                          </h4>
                          {item?.status != 3 && <GetRemainOnlyDays enddate={item?.due_date} />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>}
      <div
        className={`teamviewdetail ${viewmodel == true ? "show" : ""}`}
        isOpen={viewmodel}
      >
        <TeamsViewDetailsModel
          taskdetails={taskdetails}
          projectdetails=""
          itemdata={itemdata}
          projectid=""
          setviewModel={setviewModel}
        />
      </div>
    </div>
  );
}
